import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
// import { screenChange } from "../../store/screenSlice";

// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { TextField } from "@mui/material";
import { addCostInfo } from "../../store/eventApiSlice";
// import { DevTool } from "@hookform/devtools";
import CurrencyInput from "react-currency-input-field";
import {
  useForm,
  // Controller,
  // useFormContext,
  // Merge,
  // FieldError,
  // FieldErrorsImpl,
} from "react-hook-form";
import { Button } from "../StyledComp/StyledComp";
// import { DateValidationError } from "@mui/x-date-pickers";
// import dayjs, { Dayjs } from "dayjs";
// import { all } from "axios";
// import { invalid } from "moment";
// import ReactModal from "react-modal";
// import MemberServices from "../../services/MemberServices";
import EventService from "../../services/EventServices";

interface IConfiguration {
  [key: string]: any;
}

interface Cost {
  Id: number | null;
  CostName: string | null;
  Cost: number | null;
  EventId: number | null;
}

interface CostsFormValue {
  FormCostId1: number | null;
  FormCost1: number | null;
  FormCostId2: number | null;
  FormCost2: number | null;
  FormCostId3: number | null;
  FormCost3: number | null;
  FormCostId4: number | null;
  FormCost4: number | null;
  FormCostId5: number | null;
  FormCost5: number | null;
  FormCostId6: number | null;
  FormCost6: number | null;
}

interface ChildProps {
  closeCostModal: (flag: boolean) => void;
}

const AddCostInfo: React.FC<ChildProps> = (props) => {
  const dispatch = useDispatch();
  // dispatch(screenChange("Events"));

  // const { errors: errorsCost } = formStateCost;

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );
  console.log("event:", eventInfo);

  const { closeCostModal } = props;
  // const [costSet1, setcostSet1] = useState<Cost | null>();
  // const [costSet2, setcostSet2] = useState<Cost | null>();

  // const costList: Cost[] = [];
  // const [costValues, setcostValues] = useState<(number | null)[]>();
  // const [costList, setcostList] = useState<Cost[] | null>(eventInfo.Costs);

  const [CostId1, setCostId1] = useState<number | null>(null);
  const [CostName1, setCostName1] = useState<string>("");
  const [Cost1, setCost1] = useState<number | null>(null);
  const [CostId2, setCostId2] = useState<number | null>(null);
  const [CostName2, setCostName2] = useState<string>("");
  const [Cost2, setCost2] = useState<number | null>(null);
  const [CostId3, setCostId3] = useState<number | null>(null);
  const [CostName3, setCostName3] = useState<string>("");
  const [Cost3, setCost3] = useState<number | null>(null);
  const [CostId4, setCostId4] = useState<number | null>(null);
  const [CostName4, setCostName4] = useState<string | null>(null);
  const [Cost4, setCost4] = useState<number | null>(null);
  const [CostId5, setCostId5] = useState<number | null>(null);
  const [CostName5, setCostName5] = useState<string | null>(null);
  const [Cost5, setCost5] = useState<number | null>(null);
  const [CostId6, setCostId6] = useState<number | null>(null);
  const [CostName6, setCostName6] = useState<string | null>(null);
  const [Cost6, setCost6] = useState<number | null>(null);

  /* ----use config list as temporary place holder for cost name  */
  const [costDesc, setcostDesc] = useState<IConfiguration>([]);

  const form = useForm<CostsFormValue>();
  const { register, handleSubmit } = form;
  // const { errors } = formState;

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");

      const response = await EventService.getConfigurableCosts();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        setcostDesc(response.data.data);
      } else {
      }
    };

    getConfigurationLists();
  }, []);

  // const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
  //   console.log("key:", event.target.name, "value:", event.target.value);
  //   dispatch(
  //     updateEvent({
  //       key: event.target.name,
  //       value: event.target.value,
  //     })
  //   );
  // };

  // const onAddCostItem = (e: any) => {
  //   console.log("onAddCostItem");
  //   console.log("onAddCostItem:", e);
  // };

  // Comments: Will be accessed from both onChange and submit
  let obj1: Cost = {
    Id: CostId1,
    CostName: CostName1,
    Cost: Cost1,
    EventId: eventInfo.Id,
  };
  let obj2: Cost = {
    Id: CostId2,
    CostName: CostName2,
    Cost: Cost2,
    EventId: eventInfo.Id,
  };
  let obj3: Cost = {
    Id: CostId3,
    CostName: CostName3,
    Cost: Cost3,
    EventId: eventInfo.Id,
  };
  let obj4: Cost = {
    Id: CostId4,
    CostName: CostName4,
    Cost: Cost4,
    EventId: eventInfo.Id,
  };
  let obj5: Cost = {
    Id: CostId5,
    CostName: CostName5,
    Cost: Cost5,
    EventId: eventInfo.Id,
  };
  let obj6: Cost = {
    Id: CostId6,
    CostName: CostName6,
    Cost: Cost6,
    EventId: eventInfo.Id,
  };

  const onChangeHandler = (e: any) => {
    console.log("value", e.target.value);
    console.log("name", e.target.name);
    switch (e.target.name) {
      case "FormCostId1":
        obj1 = {
          Id: e.target.options.selectedIndex,
          CostName: e.target.value,
          Cost: Cost1,
          EventId: eventInfo.Id,
        };
        setCostId1(e.target.options.selectedIndex);
        setCostName1(e.target.value);
        break;
      case "FormCost1":
        obj1 = {
          Id: CostId1,
          CostName: CostName1,
          Cost: e.target.value,
          EventId: eventInfo.Id,
        };
        setCost1(e.target.value);
        break;
      case "FormCostId2":
        obj2 = {
          Id: e.target.options.selectedIndex,
          CostName: e.target.value,
          Cost: Cost2,
          EventId: eventInfo.Id,
        };
        console.log("obj2-1:", obj2);
        setCostId2(e.target.options.selectedIndex);
        setCostName2(e.target.value);
        break;
      case "FormCost2":
        obj2 = {
          Id: CostId2,
          CostName: CostName2,
          Cost: e.target.value,
          EventId: eventInfo.Id,
        };
        setCost2(e.target.value);
        console.log("obj2-1:", obj2);
        break;
      case "FormCostId3":
        obj3 = {
          Id: e.target.options.selectedIndex,
          CostName: e.target.value,
          Cost: Cost3,
          EventId: eventInfo.Id,
        };
        setCostId3(e.target.options.selectedIndex);
        setCostName3(e.target.value);
        break;
      case "FormCost3":
        obj3 = {
          Id: CostId3,
          CostName: CostName3,
          Cost: e.target.value,
          EventId: eventInfo.Id,
        };
        setCost3(e.target.value);
        break;
      case "FormCostId4":
        obj4 = {
          Id: e.target.options.selectedIndex,
          CostName: e.target.value,
          Cost: Cost4,
          EventId: eventInfo.Id,
        };
        setCostId4(e.target.options.selectedIndex);
        setCostName4(e.target.value);
        break;
      case "FormCost4":
        obj4 = {
          Id: CostId4,
          CostName: CostName4,
          Cost: e.target.value,
          EventId: eventInfo.Id,
        };
        setCost4(e.target.value);
        break;
      case "FormCostId5":
        obj5 = {
          Id: e.target.options.selectedIndex,
          CostName: e.target.value,
          Cost: Cost5,
          EventId: eventInfo.Id,
        };
        setCostId5(e.target.options.selectedIndex);
        setCostName5(e.target.value);
        break;
      case "FormCost5":
        obj5 = {
          Id: CostId5,
          CostName: CostName5,
          Cost: e.target.value,
          EventId: eventInfo.Id,
        };
        setCost5(e.target.value);
        break;
      case "FormCostId6":
        obj6 = {
          Id: e.target.options.selectedIndex,
          CostName: e.target.value,
          Cost: Cost6,
          EventId: eventInfo.Id,
        };
        setCostId6(e.target.options.selectedIndex);
        setCostName6(e.target.value);
        break;
      case "FormCost6":
        obj6 = {
          Id: CostId6,
          CostName: CostName6,
          Cost: e.target.value,
          EventId: eventInfo.Id,
        };
        setCost6(e.target.value);
        break;
      default:
        console.log("Default case called");
        break;
    }
    // console.log("object1:", obj1);
    // console.log("object1:", obj2);
    // console.log("object1:", obj3);

    /* push obj1 to store  */
  };
  const onSubmit = (e: any) => {
    console.log("SUBMIT");
    if (obj1.Id != null && obj1.Cost != null) {
      dispatch(
        addCostInfo({
          key: "Costs",
          value: obj1,
        })
      );
    } else if (
      (obj1.Id == null && obj1.Cost != null) ||
      (obj1.Id != null && obj1.Cost == null)
    ) {
      alert("Please enter both cost desc and cost");
    }

    // obj2
    if (obj2.Id != null && obj2.Cost != null) {
      console.log("object1:", obj1);
      dispatch(
        addCostInfo({
          key: "Costs",
          value: obj2,
        })
      );
    } else if (
      (obj2.Id == null && obj2.Cost != null) ||
      (obj2.Id != null && obj2.Cost == null)
    ) {
      alert("Please enter both cost desc and cost");
    }

    // obj3
    if (obj3.Id != null && obj3.Cost != null) {
      console.log("object1:", obj3);
      dispatch(
        addCostInfo({
          key: "Costs",
          value: obj3,
        })
      );
    } else if (
      (obj3.Id == null && obj3.Cost != null) ||
      (obj3.Id != null && obj3.Cost == null)
    ) {
      alert("Please enter both cost desc and cost");
    }

    // obj4
    if (obj4.Id != null && obj4.Cost != null) {
      console.log("object1:", obj4);
      dispatch(
        addCostInfo({
          key: "Costs",
          value: obj4,
        })
      );
    } else if (
      (obj4.Id == null && obj4.Cost != null) ||
      (obj4.Id != null && obj4.Cost == null)
    ) {
      alert("Please enter both cost desc and cost");
    }

    // obj5
    if (obj5.Id != null && obj5.Cost != null) {
      console.log("object1:", obj5);
      dispatch(
        addCostInfo({
          key: "Costs",
          value: obj5,
        })
      );
    } else if (
      (obj5.Id == null && obj5.Cost != null) ||
      (obj5.Id != null && obj5.Cost == null)
    ) {
      alert("Please enter both cost desc and cost");
    }

    // obj6
    if (obj6.Id != null && obj6.Cost != null) {
      console.log("object1:", obj6);
      dispatch(
        addCostInfo({
          key: "Costs",
          value: obj6,
        })
      );
    } else if (
      (obj6.Id == null && obj6.Cost != null) ||
      (obj6.Id != null && obj6.Cost == null)
    ) {
      alert("Please enter both cost desc and cost");
    }
    console.log("AFTER ALERT");
    closeCostModal(false);
  };

  return (
    <>
      <form
        // key={2}
        // className="form-wrapper-space-around verticalScroll"
        style={{ width: "100%", height: "90%" }}
        onSubmit={handleSubmit(onSubmit)} //{handleSubmit(onSubmitEditPersonalInfo)}
        noValidate
      >
        <div
          className="form-wrapper-space-around verticalScroll"
          style={{ height: "85%" }}
        >
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormCostId1"
                {...register("FormCostId1")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              >
                <option value={""}> Select Cost Description </option>
                {costDesc?.map((item: any) => (
                  <option key={item.Id} value={item.CostName}>
                    {item.CostName}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormCostId1">
                Cost Name
              </label>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost1"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost1")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost1">
                Cost
              </label>
            </div>
          </div>

          {/* line 2 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormCostId2"
                {...register("FormCostId2")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              >
                <option value={""}> Select Cost Description </option>
                {costDesc?.map((item: any) => (
                  <option key={item.Id} value={item.CostName}>
                    {item.CostName}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormCostId2">
                Cost Name
              </label>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost2"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost2")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                decimalsLimit={2}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost2">
                Cost
              </label>
            </div>
          </div>

          {/* line 3 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormCostId3"
                {...register("FormCostId3")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              >
                <option value={""}> Select Cost Description </option>
                {costDesc?.map((item: any) => (
                  <option key={item.Id} value={item.CostName}>
                    {item.CostName}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormCostId3">
                Cost Name
              </label>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost3"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost3")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost3">
                Cost
              </label>
            </div>
          </div>

          {/* line 4 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormCostId4"
                {...register("FormCostId4")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              >
                <option value={""}> Select Cost Description </option>
                {costDesc?.map((item: any) => (
                  <option key={item.Id} value={item.CostName}>
                    {item.CostName}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormCostId4">
                Cost Name
              </label>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost4"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost4")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost4">
                Cost
              </label>
            </div>
          </div>

          {/* line 5 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormCostId5"
                {...register("FormCostId5")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              >
                <option value={""}> Select Cost Description </option>
                {costDesc?.map((item: any) => (
                  <option key={item.Id} value={item.CostName}>
                    {item.CostName}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormCostId5">
                Cost Name
              </label>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost5"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost5")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost5">
                Cost
              </label>
            </div>
          </div>

          {/* line 6 */}
          <div className="horizontal-wrapper-spaceevenly">
            <div className="input-field-div-wrapper-large">
              <select
                className="dropdown-control-large-insidetextfield-new"
                id="FormCostId6"
                {...register("FormCostId6")}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              >
                <option value={""}> Select Cost Description </option>
                {costDesc?.map((item: any) => (
                  <option key={item.Id} value={item.CostName}>
                    {item.CostName}
                  </option>
                ))}
                ;
              </select>
              <label className="select-form-label" htmlFor="FormCostId6">
                Cost Name
              </label>
            </div>

            <div className="input-field-div-wrapper-smaller">
              <CurrencyInput
                className="input-field-div-small"
                id="FormCost6"
                placeholder=""
                // defaultValue={0}
                {...register("FormCost6")}
                decimalsLimit={2}
                onChange={(e) => {
                  onChangeHandler(e);
                }}
                // onValueChange={(value, name) => console.log(value, name)}
              />
              <label className="form-label" htmlFor="FormCost6">
                Cost
              </label>
            </div>
          </div>
        </div>

        <div
          className="horizontal-wrapper-centeralign"
          style={{ height: "15%" }}
        >
          <div className="submit-button-div ">
            <Button type="submit">Add</Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddCostInfo;
